import React, { useState, useRef } from 'react';
import { Upload } from 'lucide-react';

interface UploadDropzoneProps {
  onFileSelect: (file: File) => void;
}

const UploadDropzone: React.FC<UploadDropzoneProps> = ({ onFileSelect }) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.name.endsWith('.csv')) {
      onFileSelect(droppedFile);
    }
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      onFileSelect(selectedFile);
    }
  };

  const handleSelectFileClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      className={`s-admin-bulk-upload-dropzone ${isDragging ? 's-admin-bulk-upload-dropzone-active' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className="s-admin-bulk-upload-dropzone-icon">
        <Upload size={32} />
      </div>
      <p className="s-admin-bulk-upload-dropzone-text">Drop your CSV file here</p>
      <p className="s-admin-bulk-upload-dropzone-subtext">or click to browse from your computer</p>
      <button className="s-admin-bulk-upload-select-btn" onClick={handleSelectFileClick}>
        Select File
      </button>
      <p className="s-admin-bulk-upload-dropzone-hint">Supports .csv files up to 10MB</p>
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv"
        onChange={handleFileInputChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default UploadDropzone;
